export default __webpack_public_path__ + "static/media/rolesVisualDesign.5b1e7cab.svg";